import { useLoginHref } from '@hooks/useLoginHref';
import Button from '@components/atoms/button';
import Icon from '@components/atoms/icon';
import {
  BodyRegular,
  BodySmallRegular,
  H1
} from '@components/atoms/typography';
import FFHModal from '@components/modal';

const FreeMemberModal = ({ isOpen, setIsOpen, title, description }) => {
  const loginHref = useLoginHref();
  const signupHref = useLoginHref(undefined, { screen_hint: 'signup' });

  return (
    <FFHModal
      open={isOpen}
      handleClose={() => setIsOpen(false)}
      childrenClassName="w-11/12 md:w-6/12 p-8 h-[50vh]"
    >
      <div className="flex flex-col items-center justify-center h-full">
        <Icon name="CheckCircle" className="w-20 h-20 text-primary-600 mb-3" />
        <H1 className="text-center">{title}</H1>
        <BodyRegular className="mt-2 mb-5 text-center">
          {description}
        </BodyRegular>
        <Button href={signupHref} variant="primary">
          Sign Up for free
        </Button>
        <BodySmallRegular
          href={loginHref}
          prefetch={false}
          className="text-primary-600 pointer mt-5"
        >
          Already a member? Log in
        </BodySmallRegular>
      </div>
    </FFHModal>
  );
};

export default FreeMemberModal;
